import {Component, ContentChild, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {MatSort} from '@angular/material/sort';
import {SettingsService} from 'src/app/services/settings.service';
import {AllDetailsComponentComponent} from 'src/app/shared/all-details-component/all-details-component.component';
import {CLICK_RESET_TIME, SECRECT_CLICK_THRESHOLD} from 'src/app/shared/constants/constants';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator, PageEvent} from "@angular/material/paginator";

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit, OnDestroy {

  @Input() tableData: any;
  @Input() columnHeader;
  @Input() hasActionsColumn = true;
  objectKeys = Object.keys;
  listData: MatTableDataSource<any>;
  searchKey: string;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ContentChild(TemplateRef, {static : true}) actions: TemplateRef<any>;
  subscriptions: Subscription = new Subscription();
  actionColumn: boolean;

  @Output() search;
  @Output() pageEvent;

  constructor(
    private settingsService:SettingsService,
  ) {

  }

  ngOnInit() {
    this.actionColumn = this.hasActionsColumn;
    this.subscriptions.add(
      this.tableData.subscribe(data => {
        this.listData = new MatTableDataSource(data);
        this.listData.sort = this.sort;
        this.listData.paginator = this.paginator;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  filterTable() {
    this.listData.filter = this.searchKey.trim().toLowerCase();
  }

  onSearchClear() {
    this.searchKey = '';
    this.filterTable();
  }

   handlePage($event: PageEvent) {

   }

   trigger = 0;
   triggerTimer;
   viewDetails(data){
    if(++this.trigger < SECRECT_CLICK_THRESHOLD) return false;
    if(!this.triggerTimer) this.triggerTimer = setInterval(()=>{this.trigger=0},CLICK_RESET_TIME)

    this.settingsService.openDialogModal({
      component: AllDetailsComponentComponent,
      width: '70%',
      panelClass: ['full-screen-dialog'],
      height: '100%',
      position: { top: '0', right: '0' },
      // width: '70%',
      // height: '90%',
      data: data,
    });
  }

}
